import React, { useState } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  TextField,
  Typography,
  Card,
  IconButton,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { Eye as EyeIcon } from 'react-feather'

import {
  ExpandMore as ExpandMoreIcon,
  HelpOutline as HelpOutlineIcon,
  Reorder as ReorderIcon,
} from '@material-ui/icons'
import { isEmpty } from 'lodash'

import { LoadingFeedback } from 'components'
import { DialogView } from './components'
import useFetch from 'hooks/useFetch'
import * as service from 'service'
import useStyles from './styles'

const StepPreviewCourse = ({ courseId }) => {
  const classes = useStyles()
  const [lessonViewData, setLessonViewData] = useState({
    open: false,
    lesson: null,
  })

  const { response: courseResponse, isLoading: isCourseLoading } = useFetch(
    service.dponet.trainingCourse.show,
    { courseId },
    [courseId],
  )

  const { response: modulesResponse, isLoading: isModulesLoading } = useFetch(
    service.dponet.trainingCourse.modules,
    { courseId },
    [courseId],
  )

  const course = courseResponse?.data?.course ?? {}
  const courseModules = modulesResponse?.data?.modules ?? []
  const categories = course?.categories ?? []

  const onViewer = (lesson) => setLessonViewData({ open: true, lesson })
  const onClose = () => setLessonViewData({ open: false, lesson: null })

  return (
    <>
      <LoadingFeedback open={isCourseLoading || isModulesLoading} />
      <Card className={classes.section}>
        <Box p={2}>
          <Typography className={classes.sectionTitle}>
            Informações Básicas
          </Typography>

          <Grid container spacing={3} alignItems="flex-start">
            <Grid item xs={12} sm="auto">
              {course?.thumbnailUrl ? (
                <img
                  src={course.thumbnailUrl}
                  alt="Thumbnail do curso"
                  className={classes.thumbnail}
                />
              ) : (
                <Box className={classes.thumbnailPlaceholder} />
              )}
            </Grid>
            <Grid item xs={12} sm>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Nome do Curso"
                    value={course?.title ?? ''}
                    variant="outlined"
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Descrição"
                    value={course?.description ?? ''}
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={10}
                    maxRows={10}
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    value={categories}
                    options={categories}
                    getOptionLabel={(option) => option.name}
                    disabled
                    disableClearable
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Categoria"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>

      <Box className={classes.section}>
        <Typography className={classes.sectionTitle}>Módulos</Typography>

        {courseModules.map((courseModule, moduleIndex) => (
          <Accordion
            key={courseModule.id}
            className={classes.accordion}
            variant="outlined"
            defaultExpanded={true}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classes.accordionSummary}
            >
              <Typography className={classes.accordionSummary}>
                {`Módulo ${moduleIndex + 1} - ${courseModule.title}`}
              </Typography>
            </AccordionSummary>

            <AccordionDetails className={classes.accordionDetails}>
              <TextField
                label="Nome do Módulo"
                value={courseModule.title ?? ''}
                disabled
                variant="outlined"
                fullWidth
              />
              <TextField
                label="Descrição"
                value={courseModule.description ?? ''}
                disabled
                variant="outlined"
                fullWidth
                multiline
                minRows={3}
                maxRows={3}
              />

              {!isEmpty(courseModule.lessons) && (
                <Box>
                  <Typography className={classes.lessonsLabel}>
                    Aulas
                  </Typography>
                  {courseModule.lessons.map((lesson, lessonIndex) => (
                    <Box key={lesson?.id} className={classes.lessonRow}>
                      {lesson.kind === 'exercise' ? (
                        <HelpOutlineIcon className={classes.lessonIcon} />
                      ) : (
                        <ReorderIcon className={classes.lessonIcon} />
                      )}
                      <Typography className={classes.lessonTitle}>
                        {`${moduleIndex + 1}.${lessonIndex + 1} - ${
                          lesson?.title
                        }`}
                      </Typography>
                      <IconButton onClick={() => onViewer(lesson)}>
                        <EyeIcon size={20} />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
      {lessonViewData.open && (
        <DialogView
          onClose={onClose}
          open={lessonViewData.open}
          lesson={lessonViewData.lesson}
          courseModules={courseModules}
        />
      )}
    </>
  )
}

export default StepPreviewCourse
